import Marker from "./Marker";
import Resource from "./resource";
import ResourceCollection from "./resource-collection";
import Viewer from "./viewer";

export default {
  Marker,
  Resource,
  ResourceCollection,
  Viewer
};
